import { Head, Link } from "@inertiajs/react";
import { Heart, ChevronLeft, ChevronRight } from "lucide-react";
import SchoolLayout from "@/components/schools/SchoolLayout";
import { Button } from "@/components/ui/button";
import EmptyState from "@/components/EmptyState";
import TransactionsTable from "@/components/schools/TransactionsTable";
import { formatMoney, pluralize } from "@/lib/format";

export default function Transactions({ school, membership, campaign_name, paid_total_cents, donations, pagination }) {
  return (
    <SchoolLayout school={school} membership={membership} eyebrow={campaign_name} title="Donations">
      <Head title="Donations" />

      <div className="space-y-6">
        <p className="text-sm text-muted-foreground">
          {pluralize(pagination.total, "donation")} ·{" "}
          <span className="font-semibold text-primary font-tabular">{formatMoney(paid_total_cents)}</span> raised
        </p>

        {donations.length === 0 ? (
          <EmptyState
            icon={Heart}
            title="No donations yet"
            description="They'll appear here as they come in."
          />
        ) : (
          <TransactionsTable donations={donations} />
        )}

        {pagination.total_pages > 1 && (
          <nav aria-label="Pages" className="flex items-center justify-between pt-2">
            <p className="text-sm text-muted-foreground">
              Page {pagination.page} of {pagination.total_pages}
            </p>
            <div className="flex gap-2">
              <PageLink href={pagination.previous_path}>
                <ChevronLeft className="h-4 w-4" />
                Previous
              </PageLink>
              <PageLink href={pagination.next_path}>
                Next
                <ChevronRight className="h-4 w-4" />
              </PageLink>
            </div>
          </nav>
        )}
      </div>
    </SchoolLayout>
  );
}

function PageLink({ href, children }) {
  if (!href) return <Button variant="outline" size="sm" disabled>{children}</Button>;
  return (
    <Button variant="outline" size="sm" asChild>
      <Link href={href} preserveScroll>{children}</Link>
    </Button>
  );
}
